import axios from "./HttpRequestTracking";


function  getsessionid(){
    return axios.get('/v1/tracking/session-id');
}
function  pushtracking(sessionId, userId,phone ,url, location,x,y,TrackingAction,TrackingActionType,skusOnScreen,brand, time=0){
    const param = {
        "source": 3,
        "sessionId": sessionId,
        "userId": userId,
        "phone": phone,
        "screenName": url,
        "location": location,//sự kiện 
        "position": {
            "x": x,
            "y": y
        },
        "action": "TrackingAction."+TrackingAction,//TrackingAction.cart
        "actionType": "TrackingActionType."+TrackingActionType,//TrackingActionType.inApp
        "date": Date.now(),
        "actionTimeMs": time,
        "skusOnScreen": skusOnScreen,
        "deviceInfo": {
            "deviceId": null,
            "brand": brand,
            "operatingSystem": null,
            "sdk": null
        },
        "key": '',
        "versionApp": "1.0.0.0"
    }
    return axios.post('/v1/tracking/events', param);
}


export {getsessionid, pushtracking}